import displacementVideo from "../../../../src/images/motion/displacement-gold.mp4";
import * as React from 'react';
export default {
  displacementVideo,
  React
};